import { ChangeDetectionStrategy, Component, inject, input, model } from '@angular/core';
import { DateService, Nullable } from '@softline/core';
import {
  DateRangePickerComponent,
  defaultDateRangeShortcuts
} from '../../../components/picker/date-range-picker/date-range-picker.component';
import { ResolvableModal } from '../../abstraction/modal';
import { I18nModule } from '../../../i18n/i18n.module';
import { DateRange } from '../../types/date-range';
import { FormatPipe } from '../../../l10n/pipes/format.pipe';

@Component({
  selector: 'soft-date-range-input-dialog',
  templateUrl: './date-range-picker-modal.component.html',
  styleUrls: ['./date-range-picker-modal.component.css'],
  imports: [I18nModule, DateRangePickerComponent, FormatPipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DateRangePickerModalComponent extends ResolvableModal<DateRange | null> {
  readonly dateService = inject(DateService);
  readonly today = {from: this.dateService.now(), to: this.dateService.now()};

  title = input<string | null>();
  subtitle = input<string | null>();
  value = model<DateRange | null>(null);
  shortcuts = input<{ value: DateRange; label: string }[] | null>(null);

  onValueChange(value: Nullable<DateRange> | null): void {
    if (value && value.from && value.to) {
      this.resolve({from: value.from, to: value.to});
    }
  }
}
